import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '../consts/url';
import { OrgUsersMapResponse } from '../store/state/org-users/org-users.models';

@Injectable({ providedIn: 'root' })
export class OrgUsersService {
  constructor(private readonly http: HttpClient) {}

  public getOrgUsersMap(): Observable<OrgUsersMapResponse> {
    return this.http.get<OrgUsersMapResponse>(api.orgUsers.map);
  }

  public getUsersByIds(userIds: string[]): Observable<OrgUsersMapResponse> {
    return this.http.post<OrgUsersMapResponse>(api.orgUsers.byIds, { userIds });
  }
}
